<template>
    <div class='microphone-button microphone-page__microphone-button'>
        <div class='microphone-button__background' v-bind:class='{ "microphone-button__background_active" : isActive }'>
            <div class='microphone-button__button' 
                   v-on:click.left='switchRecording'
                >
                <font-awesome-icon class='microphone-button__icon' icon='microphone'></font-awesome-icon>
            </div>
        </div>
    </div>
</template>

<script>
//    v-on:mousedown='switchRecording' 
//    v-on:mouseup='switchRecording'
export default {
    name: 'MicrophoneButton',
    data: function() {
        return {
            isActive: false,
            mediaRecorder: '',
            audioChunks: []
        }
    },
    sockets: {
        connect: function() {
            console.log('Соединение установлено');
        }
    },
    methods: {
        switchRecording: function() {
            !this.isActive ? this.startRecording() : this.stopRecording();
        },
        startRecording: function() {
            this.isActive = true;   
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(stream => {
                this.mediaRecorder = new MediaRecorder(stream);
                this.mediaRecorder.start();
                console.log(this.mediaRecorder);
                this.mediaRecorder.addEventListener("dataavailable", event => {
                    this.audioChunks.push(event.data);
                    this.$socket.emit('audioMessage', this.audioChunks);
                });
            });
        },
        stopRecording: function() {
            this.isActive = false;
            this.mediaRecorder.stop();
        }
    }
}
</script>

<style lang='less'>
@green_dark: #41B883;

.microphone-button {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;

    &__background {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #66DCAC;
        border-radius: 50%;
        transition: width 0.1s ease-in-out, height 0.1s ease-in-out;

        &_active {
            width: 200px;
            height: 200px;
        }
    }

    &__button {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: @green_dark;
    }

    &__icon {
        color: #E4FFF4;
        font-size: 60px;
    }
}

.microphone-page__microphone-button {
    margin-top: 132px;
}

.microphone-button_icon {}
</style>